<template id="view-grid">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <ejs-grid
          ref="gridObj"
          class="r-space"
          :toolbarClick="toolbar_click"
          :actionBegin="onActionBegin"
          :actionComplete="onActionComplete"
          :toolbar="toolbar"
          :query="query"
          :allowSorting="true"
          :allowSelection="true"
          :allowExcelExport="true"
          :allowFiltering="true"
          :allowPaging="true"
          :allowGrouping="false"
          :pageSettings="pageSettings"
          :filterSettings="filterSettings"
          :dataBound="dataBound"
          locale="es-CO"
          :load="load"
          :queryCellInfo="setStyle"
          :commandClick="gridCommandClick"
        >
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";
import { DialogUtility } from "@syncfusion/ej2-popups";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { TooltipPlugin, Tooltip } from "@syncfusion/ej2-vue-popups";

import {
  GridPlugin,
  Edit,
  Filter,
  Group,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort,
  ExcelExport,
  Resize
} from "@syncfusion/ej2-vue-grids";

Vue.use(GridPlugin);
Vue.use(TooltipPlugin);

export default Vue.extend({
  name: "Grid",
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  created() {},
  async mounted() {
    this.setDefaultToolbar();
    if (!this.hasRecharge) {
      if (this.toolbar != undefined) {
        this.toolbar.pop();
      }
    }
  },
  async beforeUnmount() {
    try {
      this.$refs.gridObj.ej2Instances.columns = [];
    } catch (error) {
      console.log(error);
    }
  },
  computed: {},
  // updated() {
  //   this.$refs.gridObj.ej2Instances.dataSource = this.gridData;
  // },
  data() {
    return {
      /* Datos del Grid */
      toolTip: "",
      pageSettings: { pageCount: 5, pageSize: 10 },
      allowSorting: true,
      filterSettings: {
        mode: "Immediate",
        immediatemodedelay: 0,
        type: Browser.isDevice ? "Menu" : "FilterBar",
        ignoreAccent: true,
        columns: []
      },
      editparams: { params: { popupHeight: "300px" } },
      selectionSettings: { persistSelection: true },
      editSettings: {
        showDeleteConfirmDialog: true,
        allowEditing: true,
        allowEditOnDblClick: false,
        allowAdding: true,
        allowDeleting: false,

        mode: "Dialog"
      },
      filter: { type: "CheckBox" },
      query: "",
      gridColumns: []
    };
  },
  provide: {
    grid: [
      Edit,
      Group,
      Sort,
      Filter,
      Page,
      Selection,
      CommandColumn,
      Toolbar,
      ExcelExport,
      Tooltip,
      Resize
    ]
  },
  methods: {
    gridCommandClick(args) {
      // console.log(args);
      this.$emit("commandClicked", args);
      if (args.target.classList.contains("not-allowed")) return;

      if (args.target.title == "Consultar") {
        this.viewTool_click(args);
      }

      if (args.target.title == "Editar") {
        this.editTool_click(args);
      }

      if (args.target.title == "Eliminar") {
        this.deleteTool_click(args);
      }

      if (args.target.title == "Duplicar") {
        this.duplicateTool_click(args);
      }
    },
    onActionBegin: function (args) {
      try {
        if (args.requestType === "refresh") {
          this.$refs.gridObj.showSpinner();
        }

        if (args.requestType === "filtering") {
          if (args.columns && args.columns.length) {
            args.columns.forEach((col) => {
              col.operator = "contains"; // set the “contains” operator for the ‘CustomerID’ column
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    onActionComplete: function (args) {
      if (args.requestType === "refresh") {
        this.$refs.gridObj.hideSpinner();
      }
    },
    async toolbar_click(args) {
      if (args.item.id === "deleteTool") {
        this.deleteTool_click(args);
      }

      if (args.item.id === "addTool") {
        this.addTool_click();
      }

      if (args.item.id === "viewTool") {
        this.viewTool_click(args);
      }

      if (args.item.id === "editTool") {
        this.editTool_click(args);
      }

      if (args.item.id === "exportTool") {
        this.exportTool_click(args);
      }

      if (args.item.id === "reloadTool") {
        this.$emit("reloadData");
      }

      if (args.item.id === "duplicateTool") {
        this.duplicateTool_click(args);
      }
    },
    exportTool_click() {
      if (!this.hasPermission("CanExport")) {
        alert("Permiso denegado");
        return;
      }

      let hora = new Date().toISOString().slice(0, 10);
      let fName = this.gridName + hora + ".xlsx";
      let exportProps = {
        fileName: fName,
        includeHiddenColumn: false
      };

      this.$refs.gridObj.excelExport(exportProps);
    },
    deleteTool_click(args) {
      this.$emit("deleteData", this.getData(args));
    },
    addTool_click() {
      this.$emit("addNew");
    },
    viewTool_click(args) {
      this.$emit("viewData", this.getData(args));
    },
    editTool_click(args) {
      this.$emit("editData", this.getData(args));
    },
    duplicateTool_click(args) {
      this.$emit("duplicateData", this.getData(args));
    },
    getData(args) {
      let rowData = null;
      var isToolbar = args == undefined || args.name == "toolbarClick";

      if (isToolbar) {
        rowData = this.getRowDataFromToolbar();
      } else {
        rowData = this.getRowData(args);
      }
      return rowData;
    },
    getRowDataFromToolbar() {
      var rows = this.$refs.gridObj.ej2Instances.getSelectedRows()[0];

      if (!rows) {
        var dlg = this.getAlertDialog(
          "Seleccione Item",
          "No ha seleccionado ningún item"
        );

        dlg.show();
        return null;
      }

      let rowObj = this.$refs.gridObj.ej2Instances.getRowObjectFromUID(
        rows.getAttribute("data-uid")
      );

      return rowObj.data;
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    getRowData: function (args) {
      /* Consultar los datos si le dan Doble click al grid */
      if (args.type === "actionBegin" && args.requestType === "beginEdit") {
        return args.rowData;
      }

      /* Determinar a que fué que le dieron click, si a la etiqueta o al botón.*/
      var target = args.target;
      /* Si la etiqueta tiene la clase e-edit, es el label y no el botón (Validar si mejor se agrega otra clase) */
      if (target != undefined) {
        if (target.classList.contains("inline-command")) {
          target = target.parentElement;
        }
      }

      /*Después de tener identificado el Target, entonces buscamos la fila seleccionada */
      let rowObj = this.$refs.gridObj.ej2Instances.getRowObjectFromUID(
        target.parentElement.parentElement.parentElement.getAttribute(
          "data-uid"
        )
      );
      //setear los datos.
      return rowObj.data;
    },
    load() {
      // this.$refs.gridObj.ej2Instances.columns = this.gridColumns;
      // this.$refs.gridObj.ej2Instances.autoFitColumns();
    },
    clearDataGrid(retry = true) {
      try {
        this.$refs.gridObj.ej2Instances.clearCellSelection();
        this.$refs.gridObj.ej2Instances.clearRowSelection();
        this.$refs.gridObj.ej2Instances.clearSelection();
        this.$refs.gridObj.ej2Instances.clearFiltering();
        this.$refs.gridObj.ej2Instances.clearSorting();
        this.$refs.gridObj.ej2Instances.clearGrouping();
        this.$refs.gridObj.ej2Instances.dataSource = [];
        this.$refs.gridObj.ej2Instances.columns = [];
        this.$refs.gridObj.ej2Instances.refresh();
        this.$refs.gridObj.ej2Instances.refreshHeader();
        this.$refs.gridObj.ej2Instances.refreshColumns();
        setTimeout(() => {
          if (retry) this.clearDataGrid(false);
        }, 100);
      } catch (error) {
        console.log(error);
      }
    },
    setGridData(data, columns = null) {
      try {
        this.$refs.gridObj.ej2Instances.columns = columns || this.gridColumns;
        this.$refs.gridObj.ej2Instances.dataSource = data;

        //this.$refs.gridObj.ej2Instances.refresh();
        // this.$refs.gridObj.ej2Instances.refreshColumns();
        // this.$refs.gridObj.ej2Instances.refreshHeader();
      } catch (error) {
        console.info(error);
      }
      if (this.autoFitColumns) this.$refs.gridObj.ej2Instances.autoFitColumns();
    },
    dataBound() {
      if (this.autoFitColumns) this.$refs.gridObj.ej2Instances.autoFitColumns();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading(timeOut) {
      this.$parent.hideLoading(timeOut);
    },
    setStyle: function (args) {
      if (args.column.field === "activeName") {
        var status = args.data["activeName"];
        if (status === "Activo") {
          args.cell.classList.add("row-active");
          args.cell.classList.remove("row-inactive");
        } else {
          args.cell.classList.remove("row-active");
          args.cell.classList.add("row-inactive");
        }
      }
    }
  },
  props: {
    // gridColumns: {
    //   type: Array,
    //   required: true
    // },
    // gridData: {
    //   type: Array,
    //   required: true
    // },
    autoFitColumns: {
      type: Boolean,
      required: false,
      default: false
    },
    gridName: {
      type: String,
      required: true
    },
    hasRecharge: {
      type: Boolean,
      required: true,
      default: false
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-grids/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.e-grid .e-new.e-icons:before,
.e-grid-menu .e-new.e-icons:before {
  content: "\e823";
}

.e-grid .e-view.e-icons:before,
.e-grid-menu .e-view.e-icons:before {
  content: "\e609";
}

.e-grid .e-reload.e-icons:before,
.e-grid-menu .e-reload.e-icons:before {
  content: "\e218";
}

.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}

.e-grid .e-rowcell.row-active,
.e-grid .e-rowcell.row-active.e-selectionbackground {
  padding-left: 20px !important;
  color: #16c1e3 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  background-image: url("../../assets/img/active.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-origin: content-box;
}

.e-grid .e-rowcell.row-inactive,
.e-grid .e-rowcell.row-inactive.e-selectionbackground {
  padding-left: 20px !important;
  color: #777777 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  background-image: url("../../assets/img/inactive.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-origin: content-box;
}

.e-grid .e-pagerexternalmsg {
  display: none;
}
</style>
